import React, { useState, useEffect } from "react";

import { useLiquity } from "../../../Hooks/LiquityContext";
import { useMyTransactionState, useTransactionFunction } from "../../../Components/Transaction";
import { capitalizeFirstLetter } from "../../../Utils/string";
import { LiquityStoreState } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";
import { format } from "../../../Utils/number";

import ProgressBar from "../../../Components/ProgressBar";
import CoinAmount from "../../../Components/CoinAmount";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalCloseButton
} from "@chakra-ui/modal";
import { Flex, Text, Button, Spacer, HStack, useDisclosure } from "@chakra-ui/react";
import { Decimal } from "@liquity/lib-base";
import TransactionModal from "../../../Components/TransactionModal";

export type ConfirmDepositModalProps = {
  isOpen: boolean;
  onClose: () => void;
  mode: "deposit" | "withdraw";
  amount: string;
  total: number;
};

const selector = ({ yusdBalance, stabilityDeposit }: LiquityStoreState) => ({
  yusdBalance,
  stabilityDeposit
});

const ConfirmDepositModal: React.FC<ConfirmDepositModalProps> = ({
  isOpen,
  onClose,
  mode,
  amount,
  total
}) => {
  const { yusdBalance, stabilityDeposit } = useLiquitySelector(selector);
  const { isOpen: isTxModalOpen, onOpen: onTxModalOpen, onClose: onTxModalClosed } = useDisclosure();

  const { liquity, account } = useLiquity();

  let newAmount;

  const getFormattedValue = (value: string): number => {
    if (/^[0-9.]*$/.test(value)) {
      return +value;
    }
    return 0;
  };
  const formatedAmount = getFormattedValue(amount);
  if (mode === "deposit" && formatedAmount === format(yusdBalance)) {
    newAmount = yusdBalance;
  } else {
    if (formatedAmount === format(stabilityDeposit.currentYUSD)) {
      newAmount = stabilityDeposit.currentYUSD;
    } else {
      newAmount = formatedAmount;
    }
  }
  const transactionId = "stability-deposit";
  const [sendTransaction] = useTransactionFunction(
    transactionId,
    mode === "deposit"
      ? liquity.send.depositYUSDInStabilityPool.bind(liquity.send, newAmount, undefined)
      : liquity.send.withdrawYUSDFromStabilityPool.bind(liquity.send, newAmount)
  );

  const onDeposit = () => {
    sendTransaction();

    onClose();
    onTxModalOpen();
  };
  // useEffect(() => {
  //   console.log("amountttt", amount)
  //   newAmount = amount
  // }, [amount]);

  const action = capitalizeFirstLetter(mode) == "Deposit" ? "Stake" : "Unstake";

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize="2xl" pb={1}>
          Confirm {action}
          <ModalCloseButton />
        </ModalHeader>

        <ModalBody>
          <Flex>
            <Text fontSize="lg">{action} Amount:</Text>
            <Spacer />
            <CoinAmount
              amount={formatedAmount}
              token="YUSD"
              fontWeight="bold"
              color="white"
              fontSize="md"
            />
          </Flex>
          <Flex mt={3}>
            <Text color="brand.200">Total Staked</Text>
            <Spacer />
            <CoinAmount amount={total} token="YUSD" fontWeight="bold" />
          </Flex>
        </ModalBody>

        <ModalFooter flexDirection="column">
          <HStack spacing={6}>
            <Button variant={"primary"} onClick={onDeposit}>
              {action}
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmDepositModal;
